import { Theme, css } from '@emotion/react';

export const buttonGroup = (theme: Theme) => css`
  display: flex;
  align-items: center;
  button {
    margin: ${theme.spacing(1)}px;
  }
`;

export const dateFieldContainer = ({ spacing }: Theme) => css`
  align-items: center;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: ${spacing(1.5)}px;
`;
